import i18next, { ModuleType } from 'i18next';

// Only one feature at a time as its not cheap to branch so many keys and we
// want to keep it sane, so one mass babel migrtion at a time!
const ACTIVE_FLAG = false;

const featureBrancher = {
  name: 'featureBrancher',
  type: 'postProcessor' as ModuleType,
  process: function process(value, key: string[], options, translator) {
    const firstKey = key[0];
    if (
      translator.options.i18nFeatureBranch &&
      !firstKey.startsWith(translator.options.i18nFeatureBranch)
    ) {
      let branchedKey = `${translator.options.i18nFeatureBranch}.${firstKey}`;
      // Handle NS keys
      if (firstKey.includes(':')) {
        const parts = firstKey.split(':');
        branchedKey = `${parts[0]}:${translator.options.i18nFeatureBranch}.${parts[1]}`;
      }
      // note: need to account for _one/_other
      // todo: could alternately add a third key alongside _one/_other w/ no suffix
      // just so those would 'exist'
      if (i18next.exists(branchedKey) || i18next.exists(`${branchedKey}_one`)) {
        const newOpts = { ...options };
        if (
          Array.isArray(newOpts.postProcess) &&
          newOpts.postProcess.includes('reactPostprocessor')
        ) {
          newOpts.postProcess = ['reactPostprocessor'];
        }
        return i18next.t(branchedKey, newOpts);
      }
    }
    return value;
  },
  overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
    return {
      postProcess: 'featureBrancher',
    };
  },
};

const setupI18nextFeatureBranching = (flags?: string[] | null, i18n?) => {
  if (ACTIVE_FLAG && flags && flags.includes(ACTIVE_FLAG)) {
    i18n.options.i18nFeatureBranch = ACTIVE_FLAG;
  }
};

export default featureBrancher;
export { setupI18nextFeatureBranching };
